export const typesEntity = {
    createEntity: '[Entity] create entity',
    getEntity: '[Entity] get entity',
    deleteEntity: '[Entity] delete entity',
    updateEntity: '[Entity] update entity',
}
